import React from "react";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import { faBullseye } from "@fortawesome/free-solid-svg-icons";
function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    // <div
    //   // className={className}
    //   className="slick-arrow-icon-right"
    //   style={{
    //     ...style,
    //     // display: "block",
    //     // background: "blue",
    //     // background: "#421c52",
    //     // borderRadius: "25px",
    //     // height: "30px",
    //     // width: "30px",
    //     // justifyContent: "center",
    //     // alignItems: "center",
    //     // paddingTop: "3px",
    //   }}
    //   onClick={onClick}
    // />

    <div style={{ ...style, display: "block" }} onClick={onClick}>
      <NavigateNextIcon size="3x" className="slick-arrow-icon-right" />
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    // <div
    //   className={className}
    //   style={{
    //     ...style,
    //     display: "block",
    //     background: "#421c52",
    //     borderRadius: "25px",
    //     height: "30px",
    //     width: "30px",
    //     justifyContent: "center",
    //     alignItems: "center",
    //     paddingTop: "3px",
    //     zIndex: 22,
    //   }}
    //   onClick={onClick}
    // />

    <div style={{ ...style, display: "block" }} onClick={onClick}>
      <NavigateBeforeIcon size="3x" className="slick-arrow-icon-left" />
    </div>
  );
}

export const settings = {
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  initialSlide: 0,
  autoplay: false,
  arrows: true,
  nextArrow: <SampleNextArrow />,
  prevArrow: <SamplePrevArrow />,

  responsive: [
    {
      breakpoint: 1536,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
      },
    },
    {
      breakpoint: 1280,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
      },
    },
    {
      breakpoint: 900,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
      },
    },
    {
      breakpoint: 300,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
      },
    },
  ],
};

export const calculateSlidersData = (length) => {
  return {
    infinite: true,
    slidesToShow: length >= 4 ? 3 : length,
    speed: 900,
    autoplaySpeed: 3000,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplay: true,
    pauseOnHover: true,
    arrows: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,

    responsive: [
      {
        breakpoint: 1536,
        settings: {
          slidesToShow: length >= 4 ? 3 : length,
          slidesToScroll: 2,
          arrows: true,
        },
      },
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: length >= 3 ? 3 : length,
          slidesToScroll: 1,
          arrows: true,
        },
      },
      {
        breakpoint: 1034,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: true,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
      {
        breakpoint: 300,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  };
};

export const calculateSlidersSetting = (length) => {
  return {
    infinite: true,
    slidesToShow: length >= 4 ? 3 : length,
    speed: 900,
    autoplaySpeed: 3000,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplay: true,
    pauseOnHover: true,
    arrows: false,

    responsive: [
      {
        breakpoint: 1536,
        settings: {
          slidesToShow: length >= 4 ? 3 : length,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: length >= 3 ? 3 : length,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1034,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 300,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
};

export const settingsSecondary = {
  infinite: true,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  initialSlide: 0,
  autoplay: true,
  autoplaySpeed: 2000,
  pauseOnHover: true,
  // arrows: true,
  // nextArrow: <SampleNextArrow />,
  // prevArrow: <SamplePrevArrow />,

  responsive: [
    {
      breakpoint: 1536,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 2,
        // arrows: true,
      },
    },
    {
      breakpoint: 1280,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        // arrows: true,
      },
    },
    {
      breakpoint: 900,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        // arrows: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        // arrows: true,
      },
    },
    {
      breakpoint: 300,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        // arrows: true,
      },
    },
  ],
};

export const imageCarousalSettings = {
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  initialSlide: 0,
  dots: false,
  autoplay: true,
  autoplaySpeed: 1500,
  arrows: true,
  nextArrow: <SampleNextArrow />,
  prevArrow: <SamplePrevArrow />,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        infinite: true,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 480,
      width: 200,
      settings: {
        slidesToShow: 1,
        infinite: true,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 300,
      width: 200,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        // arrows: true,
      },
    },
  ],
};
